module.exports = __webpack_public_path__ + "studystore.89467ad6.svg";